import React, { FunctionComponent } from "react";
import Package from "../../package.json";

export const Version: FunctionComponent = () => {
    return (
        <div>&copy; WebAlert v. {Package.version}</div>
    );
}